<template>
  <div class="padres-container">
    <div class="overlay-rosado" />
    <br><br>

    <!-- Texto Padres -->
    <div class="bloque-texto">
      <div ref="texto0Ref" class="texto-container texto-novia">
        <span class="novia">Agradezco a mis Padres</span><br>
      </div>

      <div ref="texto1Ref" class="texto-container text">
        Mariana Brito <br>Roberto Duran<br>
      </div>
    </div>

   

    <!-- Separador -->
    <img ref="separadorRef" src="@/assets/separador.png" class="separador-final" alt="Separador" />

    <!-- Mariposas -->
  
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const refs = {}

    for (let i = 0; i <= 12; i++) {
      refs[`padrino${i}Ref`] = ref(null)
    }

    refs.texto0Ref = ref(null)
    refs.texto1Ref = ref(null)
    refs.separadorRef = ref(null)
    refs.mariposa1 = ref(null)
    refs.mariposa2 = ref(null)
    refs.mariposa3 = ref(null)

    const observeWithGsap = (element, delay = 0) => {
      const el = element.value
      if (!el) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            gsap.to(el, {
              opacity: 1,
              y: 0,
              duration: 1.2,
              ease: 'power3.out',
              delay,
            })
            observer.unobserve(el)
          }
        },
        { threshold: 0.2 }
      )

      el.style.opacity = 0
      el.style.transform = 'translateY(50px)'
      observer.observe(el)
    }

    onMounted(() => {
      const ordenAnimado = [
        refs.texto0Ref,
        refs.texto1Ref,
        ...Array.from({ length: 13 }, (_, i) => refs[`padrino${i}Ref`])
      ]

      ordenAnimado.forEach((refEl, index) => {
        observeWithGsap(refEl, index * 0.2)
      })

      // Separador con delay más corto
      observeWithGsap(refs.separadorRef, 0.5)

      // Animación de mariposas flotando
      const mariposas = [refs.mariposa1, refs.mariposa2, refs.mariposa3]
      mariposas.forEach((m, i) => {
        gsap.to(m.value, {
          opacity: 1,
          y: -20,
          duration: 3,
          delay: 1.5 + i * 0.5,
          ease: "power1.out",
          repeat: -1,
          yoyo: true
        })
      })
    })

    return { ...refs }
  }
}
</script>


<style scoped>
.padres-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 20px 0 0;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}

.overlay-rosado {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bloque-texto {
  margin-bottom: 40px;
  text-align: center;
}

.texto-container {
  position: relative;
  z-index: 2;
  padding: 10px;
  width: 100%;
  max-width: 600px;
  font-family: 'Dancing Script', sans-serif;
  font-size: 18px;
  color: #5c4b51;
  margin: 0 auto;
}

.novia {
  font-family: 'british', cursive;
  font-size: 22px;
  color: #7e6d21;
}

.text {
  font-size: 28px;
  color: #9c916b;
  font-family: "Dancing Script", sans-serif;
}

.padrinos-lista {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.padrino-linea {
  font-family: "Dancing Script", sans-serif;
  font-size: 20px;
  color: #9c916b;
  opacity: 0;
  transform: translateY(50px);
}

.separador-final {
  width: 80vw;
  height: auto;
  margin: 0 auto;
  display: block;
  transform: translateY(50px);
  opacity: 0;
  z-index: -2;
}

.mariposa {
  position: absolute;
  width: 60px;
  opacity: 0;
  z-index: 1;
}

.mariposa1 { top: 20%; left: 10%; }
.mariposa2 { top: 45%; right: 15%; }
.mariposa3 { top: 85%; left: 15%; }

@media (max-width: 600px) {
  .padrino-linea {
    font-size: 15px;
  }
}
</style>
